import { render, staticRenderFns } from "./folders-modal-delete.vue?vue&type=template&id=0506f432&scoped=true"
import script from "./folders-modal-delete.vue?vue&type=script&lang=js"
export * from "./folders-modal-delete.vue?vue&type=script&lang=js"
import style0 from "./folders-modal-delete.vue?vue&type=style&index=0&id=0506f432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506f432",
  null
  
)

export default component.exports